import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "templatelist"
}
const _hoisted_2 = {
  key: 2,
  class: "w-full h-full flex justify-center items-center"
}

import { getmaterials } from '@/api/affairs'
import { ElInput, ElButton, ElCascader, ElEmpty } from 'element-plus'
// @ts-ignore
import TemplateItem from './TemplateItem.vue'
import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'categoryTemplate',
  setup(__props, { expose: __expose }) {

const page = ref({
    pageNum: 1,
    pageSize: 20,
    type: 1,
})

let keywords = '';
const pagetotle = ref(0);
const templateItems = ref([]);
let category_Id = '';
const getmaterialsList = (categoryId: string | number, resetNo: boolean, Searchkeywords: string = '') => {
    if (resetNo) {
        page.value.pageNum = 1;
    }
    category_Id = categoryId.toString();
    Searchkeywords = Searchkeywords.trim();
    let params = Object.assign({}, page.value, {
        "categoryId": category_Id,
        "keywords": Searchkeywords,
        hotType: 1,// 1, 模板，2, 素材，3, 图片，4, 字体
    })
    console.log(params)
    getmaterials(params).then(res => {
        pagetotle.value = res.data.data.total;
        templateItems.value = res.data.data.list;
        console.log('templateItems.value', res.data.data.list)
    }).catch(() => {
    })
}
const searchTemplates = (categoryId: string | number, keywords: string) => {
    getmaterialsList(categoryId, true, keywords);
}

const pagechage = (val: number) => {
    page.value.pageNum = val;
    page.value = Object.assign({}, page.value)
    console.log(page.value)
    getmaterialsList(category_Id, false, keywords);
}
__expose({
    searchTemplates,
    getmaterialsList,
});

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (templateItems.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateItems.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list",
              key: item.id
            }, [
              _createVNode(TemplateItem, {
                template: item,
                type: "category"
              }, null, 8, ["template"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (pagetotle.value > page.value.pageSize)
      ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 1,
          style: {"margin-top":"20px","width":"100%"},
          background: "",
          layout: "prev, pager, next",
          small: "",
          "pager-count": "5",
          total: pagetotle.value,
          "page-size": page.value.pageSize,
          onChange: pagechage,
          ref: "pagination"
        }, null, 8, ["total", "page-size"]))
      : _createCommentVNode("", true),
    (templateItems.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(ElEmpty), { description: "暂无数据" })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})